module.exports = __webpack_public_path__ + "img/khal_img04.6e6a7e09.svg";